import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class DonationListService {

  constructor(private http: HttpClient) {}

  async getAllList(search,start,length,order,query) {
    try { 
      let response = await this.http
        // .get(`${appApiResources.getDonationList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}`)
        .get(`http://officetest.ezekiahfrancis.org/onlineoffreqs?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}&status=${query.status}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}